module.exports = __webpack_public_path__ + "static/media/location.9c35cb84.svg";